import React from 'react';
import io from 'socket.io-client';
import { Button, Row, Col, Steps, Icon } from 'antd';
import { observer, inject } from 'mobx-react';
import * as Cookies from 'js-cookie';
import { toString } from '../../lib/lib';
import styles from './DeviceControl.less';
import { DeviceInfoTab4Control } from '../../const/DataConst';
const Step = Steps.Step;

let socketIO;
@inject('deviceInfoControlStore', 'deviceInfoStore', 'loginStore')
@observer
class Tab4 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rebootCurrentStep: null,
      simCurrentStep: null,
      configCurrentStep: null,
      locationCurrentStep: null,
      appVersionCurrentStep: null,
      rebootError: false,
      simError: false,
      configError: false,
      locationError: false,
      appVersionError: false,
      rebootSuccessMsg: null,
      simSuccessMsg: null,
      configSuccessMsg: null,
      locationSuccessMsg: null,
      appVersionSuccessMsg: null
    };
    this.btnClick = this.btnClick.bind(this);
    this.successMeg = this.successMeg.bind(this);
    this.Unoccupy = this.Unoccupy.bind(this);
  }
  componentDidMount() {
    const token = Cookies.get('token');
    if (token) {
      socketIO = io(`${window.location.host}?access_token=${token}`);
    }
  }
  componentWillUnmount() {
    this.setState({
      rebootCurrentStep: null,
      simCurrentStep: null,
      configCurrentStep: null,
      locationCurrentStep: null,
      appVersionCurrentStep: null,
      rebootError: false,
      simError: false,
      configError: false,
      locationError: false,
      appVersionError: false,
      rebootSuccessMsg: null,
      simSuccessMsg: null,
      configSuccessMsg: null,
      locationSuccessMsg: null,
      appVersionSuccessMsg: null
    });
    socketIO.close();
  }
  Unoccupy(type, topic) {
    this.setState({
      [`${type}CurrentStep`]: 1
    });
    socketIO.emit('unsubscribe', topic, data => {});
    socketIO.emit('subscribe', topic, data => {});
    socketIO.on(toString(topic), data => {
      this.setState({
        [`${type}CurrentStep`]: data.step + 1,
        [`${type}Error`]: !data.status
      });
      if (data.step === 2 && data.status === 1 && type !== 'reboot') {
        this.setState({
          [`${type}SuccessMsg`]: JSON.parse(data.jsonData)
        });
      }
      if (data.step === 3 && data.status === 1 && type === 'reboot') {
        this.setState({
          [`${type}SuccessMsg`]: '重启成功'
        });
      }
    });
  }
  occupy(type, topic) {
    this.setState({
      [`${type}CurrentStep`]: 1,
      [`${type}Error`]: true
    });
    socketIO.emit('unsubscribe', topic, data => {});
  }
  btnClick(type) {
    this.props.deviceInfoControlStore
      .postControl(this.props.deviceInfoStore.deviceId, type)
      .then(json => {
        let topic = {
          type: type === 'reboot' ? 'reboot' : 'report',
          subType: type === 'reboot' ? '' : type,
          deviceId: this.props.deviceInfoStore.deviceId,
          userId: this.props.loginStore.userId
        };
        if (json.message === '1') {
          this.Unoccupy(type, topic);
        } else if (json.message === '0') {
          this.occupy(type, topic);
        }
      });
  }
  successMeg(type, jsonData) {
    switch (type) {
      case 'sim':
        return (
          <div>
            <p>上报SIM卡成功</p>
            {Object.keys(jsonData)
              .sort()
              .map(key => (
                <p key={key}>
                  {key}: {jsonData[key]}
                </p>
              ))}
          </div>
        );
      case 'config':
        return (
          <div>
            <p>上报配置成功</p>
            <p>版本号:{jsonData.version}</p>
          </div>
        );
      case 'location':
        return (
          <div>
            <p>上报位置成功</p>
            <p>系统号:{jsonData.systemId}</p>
            <p>网络号:{jsonData.networkId}</p>
            <p>基站号:{jsonData.baseStationId}</p>
            <p>地址:{jsonData.address}</p>
          </div>
        );
      case 'app':
        return (
          <div>
            <p>上报App成功</p>
            {Object.keys(jsonData).map(item => (
              <div>
                <p>App名称:{item}</p>
                <p>版本号:{jsonData[item]}</p>
              </div>
            ))}
            <p />
          </div>
        );
      case 'reboot':
        return <div>重启成功</div>;
      default:
        return;
    }
  }
  render() {
    return (
      <div className={styles.deviceInfoTab4}>
        <Row>
          {DeviceInfoTab4Control.map((item, index) => (
            <Col span={4} offset={index === 0 ? 0 : 1} key={index}>
              <Button
                className={styles.btn}
                type="primary"
                onClick={() => this.btnClick(item.type)}
              >
                {item.btnName}
              </Button>
              <div
                className={styles.stepsContainer}
                hidden={!this.state[`${item.type}CurrentStep`]}
              >
                <Steps
                  current={this.state[`${item.type}CurrentStep`] - 1}
                  direction="vertical"
                  size="small"
                  status={this.state[`${item.type}Error`] ? 'error' : 'finish'}
                >
                  {item.listArr.map((a, b) => (
                    <Step
                      icon={
                        this.state[`${item.type}Error`] ? (
                          ''
                        ) : b === this.state[`${item.type}CurrentStep`] ? (
                          <Icon type="loading" />
                        ) : (
                          ''
                        )
                      }
                      key={a}
                      description={a}
                    />
                  ))}
                </Steps>
                {this.state[`${item.type}SuccessMsg`] &&
                  this.successMeg(
                    item.type,
                    this.state[`${item.type}SuccessMsg`]
                  )}
              </div>
            </Col>
          ))}
        </Row>
      </div>
    );
  }
}
export default Tab4;



// WEBPACK FOOTER //
// ./src/components/DeviceInfo/DeviceControl.js